import type { ChartOptions } from 'chart.js';
import { defineAsyncComponent, markRaw } from 'vue';

const DEFAULT_FONT_FAMILY = "'Inter', sans-serif";

export const defaultConfig: ChartOptions = {
  scales: {
    x: {
      ticks: {
        font: {
          family: DEFAULT_FONT_FAMILY,
        },
      },
    },
    y: {
      ticks: {
        font: {
          family: DEFAULT_FONT_FAMILY,
        },
      },
    },
  },
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        font: {
          family: DEFAULT_FONT_FAMILY,
          size: 14,
        },
        color: '#34495e',
        usePointStyle: true,
      },
    },
    tooltip: {
      bodyFont: {
        size: 14,
        family: DEFAULT_FONT_FAMILY,
      },
      boxPadding: 4,
    },
  },
  datasets: {
    line: {
      fill: 'origin',
      tension: 0.3,
      borderColor: 'transparent',
    },
    bubble: {
      borderColor: 'transparent',
    },
    bar: {
      borderColor: 'transparent',
    },
  },
  maintainAspectRatio: false,
  animation: {
    duration: 1500,
  },
};

export const chartTypesMap = {
  pie: markRaw(
    defineAsyncComponent(() => import('@/components/Base/resources/BaseCharts/PieChart.vue'))
  ),
  line: markRaw(
    defineAsyncComponent(() => import('@/components/Base/resources/BaseCharts/LineChart.vue'))
  ),
  bar: markRaw(
    defineAsyncComponent(() => import('@/components/Base/resources/BaseCharts/BarChart.vue'))
  ),
};
